export const getThemeClasses = theme => {
  switch (theme) {
    case "countries":
      return {
        border: "border-blue",
        background: "bg-[#e2edff]",
        backgroundHex: "#e2edff",
        backgroundCategoryBtn: "bg-itinerary-red-500",
        backgroundQuote: "bg-itinerary-green-100",
        text: "text-blue",
        textSubMenuItems: "text-itinerary-red-500",
        textQuote: "text-itinerary-green-500",
      };
    case "cities":
      return {
        border: "border-itinerary-green-500",
        background: "bg-itinerary-green-100",
        backgroundHex: "#E7FCBF",
        backgroundCategoryBtn: "bg-itinerary-green-500",
        backgroundQuote: "bg-red-100",
        text: "text-itinerary-green-500",
        textSubMenuItems: "text-itinerary-green-500",
        textQuote: "text-bit-red",
      };
    case "regions":
      return {
        border: "border-bit-red",
        background: "bg-red-100",
        backgroundHex: "#fff0f0",
        backgroundCategoryBtn: "bg-bit-red",
        backgroundQuote: "bg-blue-100",
        text: "text-bit-red",
        textSubMenuItems: "text-bit-red",
        textQuote: "text-blue",
      };
    default:
      return {
        border: "border-blue",
        background: "bg-blue-100",
        backgroundHex: "#f0f6ff",
        backgroundCategoryBtn: "bg-itinerary-red-500",
        backgroundQuote: "bg-itinerary-green-100",
        text: "text-blue",
        textSubMenuItems: "text-itinerary-red-500",
        textQuote: "text-itinerary-green-500",
      };
  }
};
